import axios from 'axios';
import { getUserToken } from '../reducers/User/actions';
import { resetUser, setToken } from '../reducers/User/reducer';
import { store } from '../store';

const apiUrl = process.env.REACT_APP_API_ENDPOINT;
// const apiUrl = 'https://api-staging-teamsphere.greylabs.ai';
// const apiVersion = process.env.REACT_APP_API_VERSION;
const apiEndPoint = `${apiUrl}`;

const axiosInstance = axios.create({
  baseURL: apiEndPoint,
});

export const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')?.[1] || ''));
  } catch (e) {
    return null;
  }
};

const fetchRefreshToken = () => {
  let refresh_token = '';
  const tokenDetails = getUserToken();
  refresh_token = tokenDetails?.refresh || '';
  return refresh_token;
};

export const generateNewToken = async () => {
  const refreshToken = fetchRefreshToken();
  post(`/auth/token/refresh`, { refresh: refreshToken }, {}, true)
    .then((response) => {
      store.dispatch(setToken({ access: response.access, refresh: response.refresh }));
    })
    .catch((error) => {
      console.log(error);
    });
};

async function get(url, params = {}) {
  const accessToken = getUserToken()?.access || '';
  return axiosInstance
    .get(url, {
      params,
      headers: {
        'Content-Type': 'application/json',
        ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
      },
    })
    .then((response) => response.data)
    .catch(async (error) => {
      const responseStatus = error?.response?.status;
      if (responseStatus === 401 && !url.includes('token') && fetchRefreshToken()) {
        await generateNewToken();
        return get(url, params);
      }
      if (responseStatus >= 400 && responseStatus < 600) {
        return Promise.reject(error?.response?.data?.message || 'Something went wrong');
      }
      return Promise.reject(error?.response?.data?.message || 'Something went wrong');
    });
}

async function post(url, data = {}, options = {}, isRefreshToken = false) {
  const accessToken = getUserToken()?.access || '';

  return axiosInstance
    .post(url, data, {
      headers: {
        ...(!options.formData && { 'Content-Type': 'application/json' }),
        ...(accessToken && { Authorization: `Bearer ${accessToken}` }),
      },
    })
    .then((response) => response.data)
    .catch(async (error) => {
      const responseStatus = error?.response?.status;
      if (responseStatus === 401 && isRefreshToken) {
        store.dispatch(resetUser());
        window.location.href = '/login';
      }
      if (responseStatus === 401 && !url.includes('token') && fetchRefreshToken()) {
        await generateNewToken();
        return post(url, data);
      }
      if (responseStatus === 403) {
        return Promise.reject('Forbidden: You do not have the required permissions.');
      }

      if (responseStatus >= 400 && responseStatus < 600) {
        return Promise.reject(error?.response?.data?.message || 'Something went wrong');
      }
      return Promise.reject(error?.response?.data?.message || 'Something went wrong');
    });
}

export default {
  get: get,
  post: (url, body, options, isRefreshToken) => post(url, body, options, isRefreshToken),
};
